import {
  Entity,
  entityEnvelopeSchemaValidator,
  EntityMeta,
} from '@backstage/catalog-model';
import { generateAjvJsonSchemaValidator } from '../utils';
import schema from '../schema/WitboostSystemPrototype.v2alpha1.schema.json';

export interface WitboostSystemPrototype extends Entity {
  apiVersion: 'witboost.com/v2';
  kind: 'SystemPrototype';
  metadata: {
    name: string;
    description: string;
  } & EntityMeta;
  spec: {
    owner: string;
    systemPrototypeType: string;
    domain: string;
    status: string;
    instanceOf?: string;
    parameters?: Record<string, any>;
  } & Record<string, any>;
}

export const applyWitboostSystemPrototype =
  entityEnvelopeSchemaValidator<WitboostSystemPrototype>(schema);

export const witboostSystemPrototypeV2alpha1Validator =
  generateAjvJsonSchemaValidator(schema);
